import { Clock, ShieldCheck, MapPin, Workflow, UserCheck } from "lucide-react";

const items = [
  {
    icon: UserCheck,
    title: "Un seul interlocuteur",
    desc: "Un contact unique pour piloter l'ensemble du projet — fini les allers-retours entre intervenants.",
  },
  {
    icon: MapPin,
    title: "Expertise locale à La Réunion",
    desc: "Connaissance fine des PLU communaux, des sols volcaniques et des contraintes climatiques de l'île.",
  },
  {
    icon: ShieldCheck,
    title: "Projet sécurisé dès le départ",
    desc: "Étude de sol et dossier conçus de pair, sans contradictions techniques ni surcoûts imprévus.",
  },
  {
    icon: Clock,
    title: "Gain de temps",
    desc: "Un process linéaire et préparé, sans délai mort entre les étapes — vous gagnez des semaines.",
  },
  {
    icon: Workflow,
    title: "Accompagnement de A à Z",
    desc: "De la première analyse de faisabilité jusqu'au dépôt en mairie et au suivi d'instruction.",
  },
];

export default function PourquoiNous() {
  return (
    <section
      id="pourquoi"
      data-testid="pourquoi-section"
      className="py-24 md:py-32 bg-secondary border-y border-border"
    >
      <div className="container-wide">
        <div className="max-w-3xl reveal">
          <div className="flex items-center gap-3 mb-6">
            <span className="rule" />
            <span className="overline">Pourquoi nous</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-medium leading-tight text-primary">
            Pourquoi choisir{" "}
            <span className="italic font-light">Solmis Habitat</span> ?
          </h2>
        </div>

        <div className="mt-16 grid gap-px bg-border md:grid-cols-2 lg:grid-cols-3 border border-border">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`pourquoi-${i}`}
                className="reveal bg-white p-8 md:p-10 transition-all duration-300 hover:bg-[hsl(var(--brand-terra)/0.04)]"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <div className="flex items-baseline justify-between mb-6">
                  <span className="inline-flex h-11 w-11 items-center justify-center border border-border rounded-xl text-[hsl(var(--brand-terra))]">
                    <Icon size={20} strokeWidth={1.5} />
                  </span>
                  <span className="font-display text-3xl text-muted-foreground/40">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-2xl text-primary leading-snug">
                  {it.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                  {it.desc}
                </p>
              </div>
            );
          })}
          {/* Visual filler card on desktop */}
          <div className="hidden lg:flex bg-primary text-primary-foreground p-10 flex-col justify-between">
            <span className="font-display text-5xl text-[hsl(var(--brand-terra))] leading-none">
              +100
            </span>
            <div>
              <p className="text-[10px] uppercase tracking-[0.24em] text-white/60">
                Projets accompagnés
              </p>
              <p className="mt-3 text-sm text-white/85 leading-relaxed">
                Sur l'ensemble de l'île — de Saint-Denis à Saint-Pierre, en
                passant par les hauts.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
